import type { AuStateCode } from './types.js';

// Q3b: Mailing_State is a free-text Single Line in the Zanda Zoho instance, so
// values arrive as 'WA', 'Western Australia', 'W.A.', 'wa', '' — anything.
// This util maps any sensible spelling to the canonical 2-3 letter code, or
// null if the input doesn't recognise as an Australian state.
//
// Long-term Brent will convert Mailing_State to a Zoho picklist; this util
// becomes a no-op then. Until then it sits in the call path for any filter
// that touches state.

const NORMAL_MAP: Record<string, AuStateCode> = {
  WA: 'WA',
  'WESTERN AUSTRALIA': 'WA',
  NSW: 'NSW',
  'NEW SOUTH WALES': 'NSW',
  VIC: 'VIC',
  VICTORIA: 'VIC',
  QLD: 'QLD',
  QUEENSLAND: 'QLD',
  SA: 'SA',
  'SOUTH AUSTRALIA': 'SA',
  TAS: 'TAS',
  TASMANIA: 'TAS',
  ACT: 'ACT',
  'AUSTRALIAN CAPITAL TERRITORY': 'ACT',
  NT: 'NT',
  'NORTHERN TERRITORY': 'NT',
};

export function normaliseAuState(raw: string | null | undefined): AuStateCode | null {
  if (!raw) return null;
  const upper = raw.trim().toUpperCase().replace(/\./g, '');
  const collapsed = upper.replace(/\s+/g, ' ');
  // Two-pass lookup: first try the collapsed form (matches "WA" or "NEW SOUTH
  // WALES"), then a stripped form (matches "Q L D" → "QLD") so spaced-out
  // short codes from messy CRM entry still hit.
  const stripped = upper.replace(/\s+/g, '');
  return NORMAL_MAP[collapsed] ?? NORMAL_MAP[stripped] ?? null;
}

export const AU_STATE_CODES: readonly AuStateCode[] = [
  'WA',
  'NSW',
  'VIC',
  'QLD',
  'SA',
  'TAS',
  'ACT',
  'NT',
];

export const AU_STATE_LABELS: Record<AuStateCode, string> = {
  WA: 'Western Australia',
  NSW: 'New South Wales',
  VIC: 'Victoria',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  ACT: 'Australian Capital Territory',
  NT: 'Northern Territory',
};
